import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { Link } from "react-router-dom";
import Saudi_Riyal_Symbol from "../../../images/Saudi_Riyal_Symbol-1.png";

import { Col, Card, Table, Badge, ProgressBar } from "react-bootstrap";
import ProjectAchievementChart from "./ProjectAchievementChart";
import ProjectTimelineChart from "./ProjectTimelineChart";
import StudentsPerUniversityChart from "../charts/my_charts/StudentsPerUniversityChart";
import FacultyPerUniversityChart from "../charts/my_charts/FacultyPerUniversityChart";
import StartedStudentsChart from "../charts/my_charts/StartedStudentsChart";
import FacultyStudentRatioChart from "../charts/my_charts/FacultyStudentRatioChart";

const Home = () => {
  const { changeBackground, background } = useContext(ThemeContext);

  const [universities, setUniversities] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const [totalStudents, setTotalStudents] = useState([]);
  const [totalStudentsCategories, setTotalStudentsCategories] = useState([]);
  const [totalStudentsCount, setTotalStudentsCount] = useState(null);

  const [totalFaculty, setTotalFaculty] = useState([]);
  const [totalFacultyCategories, setTotalFacultyCategories] = useState([]);
  const [totalFacultyCount, setTotalFacultyCount] = useState(null);

  const [startedStudents, setStartedStudents] = useState([]);
  const [startedCategories, setStartedCategories] = useState([]);

  const [ratios, setRatios] = useState([]);
  const [ratioCategories, setRatioCategories] = useState([]);

  const [programCountStatus, setProgramCountStatus] = useState({
    approved: 0,
    not_approved: 0,
  });

  const [projectAverage, setProjectAverage] = useState({
    average_total_actual_project_price: 0,
  });

  const [rejectCompletionRate, setRejectCompletionRate] = useState({});

  const [projectAverageAmount, setProjectAverageAmount] = useState({});

  const [rankingData, setRankingData] = useState([]);
  const [topProjects, setTopProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUniversities = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://plo.areez.co/api/universities");

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();
      setUniversities(data);
    } catch (error) {
      console.error("خطأ:", error);
      setYears([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchYears = async () => {
    try {
      const response = await fetch(
        "https://plo.areez.co//api/university/academic_years"
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();
      setYears(data);
      setSelectedYear(data[0].id);
      setTimeout(() => {
        handleSearch(data[0].id);
      }, 0);
    } catch (error) {
      console.error("خطأ:", error);
      setYears([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchProgramCountStatus = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://plo.areez.co/api/programs/status/count"
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();
      setProgramCountStatus({
        approved: data.approved_programs,
        not_approved: data.not_approved_programs,
      });
    } catch (error) {
      console.error("خطأ:", error);
      setYears([]);
    } finally {
      setLoading(false);
    }
  };

  // After choosing the academic year

  const fetchTotalStudents = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/universities/total_students?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل في تحميل البيانات");

      const data = await response.json();
      const studentCounts = data.map((item) => item.total_students);
      const universityNames = data.map((item) => item.university_name);

      setTotalStudents(studentCounts);
      setTotalStudentsCategories(universityNames);
    } catch (error) {
      console.error("خطأ في تحميل البيانات:", error);
      setTotalStudents([]);
      setTotalStudentsCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalFaculty = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/universities/total_faculty?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل في تحميل البيانات");

      const data = await response.json();
      const studentCounts = data.map((item) => item.total_faculty);
      const universityNames = data.map((item) => item.university_name);

      setTotalFaculty(studentCounts);
      setTotalFacultyCategories(universityNames);
    } catch (error) {
      console.error("خطأ في تحميل البيانات:", error);
      setTotalFaculty([]);
      setTotalFacultyCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalStudentsCount = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/students/total?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل في تحميل البيانات");

      const data = await response.json();
      setTotalStudentsCount(data);
    } catch (error) {
      console.error("خطأ في تحميل البيانات:", error);
      setTotalStudentsCount(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalFacultyCount = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/faculty/total?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل في تحميل البيانات");

      const data = await response.json();
      setTotalFacultyCount(data);
    } catch (error) {
      console.error("خطأ في تحميل البيانات:", error);
      setTotalFacultyCount(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchStartedStudents = async (academicYearId) => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/universities/started_students?academic_year_id=${academicYearId}`
      );
      const result = await res.json();

      const data = result.data.map((item) => item.total_started_students);
      const categories = result.data.map((item) => item.university_name);

      setStartedStudents(data);
      setStartedCategories(categories);
    } catch (error) {
      console.error("خطأ في تحميل بيانات الطلاب الذين بدأوا:", error);
      setStartedStudents([]);
      setStartedCategories([]);
    }
  };

  const fetchFacultyStudentRatios = async (academicYearId) => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/universities/faculty_student_ratio?academic_year_id=${academicYearId}`
      );
      const result = await res.json();

      const data = result.data.map((item) => item.faculty_to_student_ratio);
      const categories = result.data.map((item) => item.university_name);

      setRatios(data);
      setRatioCategories(categories);
    } catch (error) {
      console.error("خطأ في تحميل نسبة هيئة التدريس إلى الطلاب:", error);
      setRatios([]);
      setRatioCategories([]);
    }
  };

  const handleSearch = (yearId) => {
    // if (!selectedYear) {
    //   alert("يرجى اختيار السنة الدراسية أولاً.");
    //   return;
    // }
    const yearToUse = yearId || selectedYear;
    if (!yearToUse) {
      alert("يرجى اختيار السنة الدراسية أولاً.");
      return;
    }
    setLoading(true);

    fetchTotalStudents(yearToUse);
    fetchTotalFaculty(yearToUse);
    fetchTotalStudentsCount(yearToUse);
    fetchTotalFacultyCount(yearToUse);
    fetchStartedStudents(yearToUse);
    fetchFacultyStudentRatios(yearToUse);
  };

  const fetchProjectAverage = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/average_actual_price",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setProjectAverage({
        average_total_actual_project_price:
          data.average_total_actual_project_price || 0,
      });
    } catch (err) {
      console.error("خطأ:", err);
      setProjectAverage({
        average_total_actual_project_price: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectCompletionReate = async () => {
    try {
      const res = await fetch(
        " https://promaster.areez.co/api/projects/average_achievement",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setRejectCompletionRate(data);
    } catch (err) {
      console.error("خطأ:", err);
      setRejectCompletionRate({});
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectAverageAmount = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/average_amount",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setProjectAverageAmount(data);
    } catch (err) {
      console.error("خطأ:", err);
      setProjectAverageAmount({});
    } finally {
      setLoading(false);
    }
  };

  const fetchTopProjects = async () => {
    try {
      const res = await fetch("https://promaster.areez.co/api/projects/top10", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      setTopProjects(data);
    } catch (err) {
      console.error("فشل في تحميل المشاريع:", err);
      setTopProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchRanking = async () => {
    try {
      const res = await fetch(
        "https://plo.areez.co/api/plo/university/ranking"
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setRankingData(data.data);
    } catch (err) {
      console.error("خطأ:", err);
      setRankingData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUniversities();
    fetchYears();
    fetchProgramCountStatus();

    // fetchProjectAverage();
    // fetchProjectCompletionReate();
    // fetchProjectAverageAmount();
    // fetchTopProjects();
    // fetchRanking();
    changeBackground({ value: "light", label: "Light" });
  }, []);

  const handleCompare = (program_id) => {
    let id = program_id;
    window.location.href = `/programs/compare/${id}`;
  };

  const getTrackColor = (track) => {
    switch (track) {
      case "advanced":
        return "success";
      case "on_track":
        return "info";
      case "late":
        return "danger";
      default:
        return "secondary";
    }
  };

  return (
    <div className="row">
      {/* <div className="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">الجامعات</h5>
            {loading ? (
              <p className="text-center">جاري التحميل...</p>
            ) : universities.length === 0 ? (
              <p className="text-center">لا توجد بيانات.</p>
            ) : (
              <Table responsive hover className="header-border verticle-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th className="text-center">اسم الجامعة</th>
                    <th>عمليات</th>
                  </tr>
                </thead>
                <tbody>
                  {universities.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td className="text-center">{item.name}</td>

                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => alert(`تفاصيل المشروع ID: ${item.id}`)}
                        >
                          تفاصيل
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </div>
      </div> */}
      <div className="col-12 col-lg-3">
        {/* <Link style={{ textDecoration: "none" }}> */}
          <div className="widget-stat card bg-success">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-check-circle fa-2x text-white"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">عدد البرامج المعتمدة</p>
                  <h3 className="text-white">{programCountStatus.approved}</h3>
                </div>
              </div>
            </div>
          </div>
        {/* </Link> */}
      </div>

      <div className="col-12 col-lg-3">
        {/* <Link style={{ textDecoration: "none" }}> */}
          <div className="widget-stat card bg-danger">
            <div className="card-body">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-times-circle fa-2x text-white"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">عدد البرامج غير المعتمدة</p>
                  <h3 className="text-white">
                    {programCountStatus.not_approved}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        {/* </Link> */}
      </div>

      <div className="col-lg-6 col-12">
        <div className="input-group">
          <select
            className="form-control"
            value={selectedYear || ""}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <option value="">اختر السنة الدراسية</option>
            {years.map((year) => (
              <option key={year.id} value={year.id}>
                {year.name}
              </option>
            ))}
          </select>
          <div className="input-group-append">
            <button
              className="btn btn-primary"
              // onClick={handleSearch}
              onClick={() => handleSearch(selectedYear)}
              disabled={loading}
            >
              <i className="fa fa-search mr-1"></i>{" "}
              {loading ? "جارٍ البحث..." : ""}
            </button>
          </div>
        </div>
      </div>

      {totalFacultyCount != null && (
        <div className="col-12 col-lg-6 mb-4">
          <div className="widget-stat card bg-info">
            <div className="card-body">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-id-badge fa-1x text-white"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">عدد هيئة التدريس في كل الجامعات</p>
                  <h3 className="text-white">
                    {totalFacultyCount.total_faculty}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {totalStudentsCount != null && (
        <div className="col-12 col-lg-6 mb-4">
          <div className="widget-stat card bg-primary">
            <div className="card-body">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-users fa-1x text-white"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">عدد الطلاب في كل الجامعات</p>
                  <h3 className="text-white">
                    {totalStudentsCount.total_students}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {totalStudents.length > 0 && totalStudentsCategories.length > 0 && (
        <div className="col-12 col-lg-6 mb-4">
          <StudentsPerUniversityChart
            data={totalStudents}
            categories={totalStudentsCategories}
          />
        </div>
      )}

      {totalFaculty.length > 0 && totalFacultyCategories.length > 0 && (
        <div className="col-12 col-lg-6 mb-4">
          <FacultyPerUniversityChart
            data={totalFaculty}
            categories={totalFacultyCategories}
          />
        </div>
      )}

      {startedStudents.length > 0 && (
        <div className="col-12 col-lg-6 mb-4">
          <StartedStudentsChart
            data={startedStudents}
            categories={startedCategories}
          />
        </div>
      )}

      {ratios.length > 0 && (
        <div className="col-12 col-lg-6 mb-4">
          <FacultyStudentRatioChart
            data={ratios}
            categories={ratioCategories}
          />
        </div>
      )}
{/* 
      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-muted">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-ravelry text-dark"></i>
                </span>
                <div className="media-body text-dark">
                  <p className="mb-1">متوسط قيمة الاعمال المنجزة في المشاريع</p>
                  <h3 className="text-dark">
                    {projectAverage.average_total_actual_project_price}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-primary">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-circle-o-notch text-white"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">
                    متوسط نسبة الانجاز ف المشاريع وعدد المشاريع
                  </p>
                  <h3 className="text-white">
                    {rejectCompletionRate.project_count}
                  </h3>
                  <ProgressBar
                    now={rejectCompletionRate.average_achievement_percentage}
                    variant="white"
                    style={{ height: "6px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-info">
            <div className="card-body p-4 d-flex flex-column justify-content-center align-items-center text-center text-white">
              <i className="fa fa-bar-chart fa-2x mb-3"></i>

              <h2
                className="mb-2"
                style={{ fontSize: "36px", fontWeight: "bold" }}
              >
                {Number(
                  projectAverageAmount.average_project_amount
                ).toLocaleString()}
                <span style={{ fontSize: "20px", marginRight: "4px" }}>
                  <img
                    src={Saudi_Riyal_Symbol}
                    width={30}
                    style={{ marginTop: "-20px" }}
                  />
                </span>
              </h2>

              <p className="mb-1" style={{ fontSize: "14px" }}>
                عدد المشاريع:
                <strong>{projectAverageAmount.project_count}</strong>
              </p>
              <p className="mb-0" style={{ fontSize: "13px", opacity: 0.9 }}>
                متوسط قيمة المشاريع
              </p>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-6 col-lg-12 col-sm-12">
        <div className="card p-3">
          <h5 className="mb-3">مقارنة نسب الإنجاز في المشاريع</h5>
          <ProjectAchievementChart />
        </div>
      </div>

      <div className="col-xl-6 col-lg-12 col-sm-12">
        <div className="card p-3">
          <h5 className="mb-3">
            مقارنة نسب الانجاز في المشاريع حسب الجدول الزمني
          </h5>
          <ProjectTimelineChart />
        </div>
      </div>

      <Col lg={12}>
        <Card>
          <Card.Header>
            <Card.Title>أفضل 10 مشاريع حسب الإنجاز</Card.Title>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <p className="text-center">جاري التحميل...</p>
            ) : topProjects.length === 0 ? (
              <p className="text-center">لا توجد بيانات.</p>
            ) : (
              <Table responsive hover className="header-border verticle-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>رمز المشروع</th>
                    <th>اسم المشروع</th>
                    <th>الفترة المنقضية</th>
                    <th>نسبة الإنجاز</th>
                    <th>المسار</th>
                    <th>عمليات</th>
                  </tr>
                </thead>
                <tbody>
                  {topProjects.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.code}</td>
                      <td>{item.name}</td>
                      <td>{item.elapsed_period_percentage.toFixed(2)}%</td>
                      <td>
                        <ProgressBar
                          now={item.achievement_percentage_per_project}
                          variant="primary"
                          style={{ height: "6px" }}
                        />
                        <Badge variant="primary" className="ml-2">
                          {item.achievement_percentage_per_project.toFixed(2)}%
                        </Badge>
                      </td>
                      <td>
                        <Badge variant={getTrackColor(item.project_track)}>
                          {item.project_track === "advanced"
                            ? "متقدم"
                            : item.project_track === "late"
                            ? "متأخر"
                            : "في المسار"}
                        </Badge>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => alert(`تفاصيل المشروع ID: ${item.id}`)}
                        >
                          تفاصيل
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </Col> */}
    </div>
  );
};

export default Home;
